import { setLocale } from '@hejdoktor/resx-compiler/index.mjs';
import { BootstrappedData } from './interfaces';

declare let bootstrapped: BootstrappedData;

setLocale(bootstrapped.Language);

export const bootstrappedData = bootstrapped;
